import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => {
    const storedUser = localStorage.getItem('user');
    const storedMember = localStorage.getItem('member');
    return {
      user: storedUser ? JSON.parse(storedUser) : null,
      member: storedMember ? JSON.parse(storedMember) : null,
      accessToken: localStorage.getItem('access_token'),
      refreshToken: localStorage.getItem('refresh_token'),
      balancesHidden: localStorage.getItem('balances_hidden') === 'true',
      mustChangePassword: localStorage.getItem('must_change_password') === 'true',
    };
  },
  getters: {
    isAuthenticated: (state) => !!state.accessToken,
    userName: (state) => state.user?.name || '',
    memberId: (state) => state.user?.member_id || state.member?.id || null,
    memberNumber: (state) => state.member?.member_number || '',
    userPhone: (state) => state.member?.phone || state.user?.phone || '',
    userEmail: (state) => state.user?.email || state.member?.email || '',
  },
  actions: {
    setAuth(data) {
      this.user = data.user;
      this.member = data.user?.member || null;
      this.accessToken = data.access_token;
      this.refreshToken = data.refresh_token;
      this.mustChangePassword = data.must_change_password || false;
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('must_change_password', String(this.mustChangePassword));
      if (data.user?.member) {
        localStorage.setItem('member', JSON.stringify(data.user.member));
      }
    },
    setUser(userData) {
      this.user = userData;
      localStorage.setItem('user', JSON.stringify(userData));
    },
    setTokens(access, refresh) {
      this.accessToken = access;
      this.refreshToken = refresh;
      localStorage.setItem('access_token', access);
      localStorage.setItem('refresh_token', refresh);
    },
    toggleBalances() {
      this.balancesHidden = !this.balancesHidden;
      localStorage.setItem('balances_hidden', this.balancesHidden);
    },
    logout() {
      this.user = null;
      this.member = null;
      this.accessToken = null;
      this.refreshToken = null;
      this.mustChangePassword = false;
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
      localStorage.removeItem('member');
      localStorage.removeItem('must_change_password');
    },
    clearMustChangePassword() {
      this.mustChangePassword = false;
      localStorage.setItem('must_change_password', 'false');
    },
  },
});